type AddedByMethod = { method?: string };

type OrgWithAddedBy = {
  organizationId?: string;
  added_by?: {
    added_by?: AddedByMethod | AddedByMethod[];
  };
};

const MANUAL_METHODS = ['user', 'addressbook'];

const collectAddedByMethods = (org: OrgWithAddedBy | undefined): string[] => {
  const addedBy = org?.added_by?.added_by;
  if (!addedBy) return [];
  const entries = Array.isArray(addedBy) ? addedBy : [addedBy];
  return entries.map((entry) => entry?.method).filter((m): m is string => !!m);
};

type CanEditUserEmailAddressArgs = {
  organizationSettings: OrgWithAddedBy[] | undefined;
  currentOrganizationId: string;
  isEditableEmailAddressEnabled: boolean;
};

/**
 * Email is editable only when the user was manually added (method `user` or
 * `addressbook`) in the current org AND no other org the user belongs to has
 * an external provisioning method (e.g. `scim`, `sync`). `added_by.added_by`
 * may be either a single `{ method }` object or an array of them, so both
 * shapes must be normalized before checking.
 */
export default function canEditUserEmailAddress({
  organizationSettings,
  currentOrganizationId,
  isEditableEmailAddressEnabled,
}: CanEditUserEmailAddressArgs): boolean {
  if (!isEditableEmailAddressEnabled || !organizationSettings) return false;

  const currentOrg = organizationSettings.find(
    (org) => org.organizationId === currentOrganizationId
  );
  const hasAddedBy = collectAddedByMethods(currentOrg).length > 0;
  if (!hasAddedBy) return false;

  const hasExternalProvisioning = organizationSettings.some((org) =>
    collectAddedByMethods(org).some((method) => !MANUAL_METHODS.includes(method))
  );

  return !hasExternalProvisioning;
}
